import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

@Component({
  selector: 'app-kalpita-technologies-great-place-to-work-certified',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './kalpita-technologies-great-place-to-work-certified.component.html',
  styleUrl: './kalpita-technologies-great-place-to-work-certified.component.scss'
})
export class KalpitaTechnologiesGreatPlaceToWorkCertifiedComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const gptwSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-technologies-great-place-to-work-certified",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-technologies-great-place-to-work-certified",
          "name": "Kalpita Celebrates GPTW 2025 — Kalpita Technologies",
          "description": "Kalpita Technologies secures the Great Place to Work Certification 2025 for the 4th consecutive year since 2022, reflecting its people-first culture and trust-based employee-centric workplace.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".softwaredev-heading",
              ".takeaways-section .takeaway-item p",
              ".section-title"
            ]
          },
          "significantLink": [
            "https://businesssuccessstory.com/kalpita-technologies-secures-great-place-to-work-certification-2025-for-the-4th-consecutive-year/"
          ],
          "datePublished": "2025-08-21",
          "dateModified": "2025-08-21",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-technologies-great-place-to-work-certified#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "News", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews" },
            { "@type": "ListItem", "position": 3, "name": "GPTW 2025", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/kalpita-technologies-great-place-to-work-certified" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Kalpita Technologies Secures Great Place to Work Certification 2025 for the 4th Consecutive Year",
          "alternativeHeadline": "A People-First Culture Built on Trust, Empowerment, and Innovation-Driven Growth",
          "articleBody": "Kalpita Technologies, a leading enterprise software development company headquartered in Bengaluru, India, has acquired its Great Place to Work Certification for the fourth successive year...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-08-21"
        },
        {
          "@type": "HowTo",
          "name": "How to Build a Great Place to Work Culture Like Kalpita Technologies",
          "step": [
            { "@type": "HowToStep", "name": "Prioritize Well-Being", "text": "Build a workplace where employees feel valued and supported at the heart of every project." },
            { "@type": "HowToStep", "name": "Foster Trust", "text": "Create a high-trust workplace that encourages innovation both personally and professionally." },
            { "@type": "HowToStep", "name": "Invest in Fresh Talent", "text": "Nurture next-generation talent through mentorship programs like 'Future Coders'." },
            { "@type": "HowToStep", "name": "Industry Innovation", "text": "Focus on human-centered AI solutions to drive real-world impact across global industries." },
            { "@type": "HowToStep", "name": "Benchmarking", "text": "Apply for annual certifications to benchmark your workplace against global high-trust standards." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What makes Kalpita Technologies a great place to work?",
              "acceptedAnswer": { "@type": "Answer", "text": "A culture built on trust and empowerment, prioritized employee well-being, and continuous learning opportunities." }
            },
            {
              "@type": "Question",
              "name": "What are the Future Coders programs?",
              "acceptedAnswer": { "@type": "Answer", "text": "A talent initiative that hires and mentors freshers through rigorous training in the latest technologies." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(gptwSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
}
